<template>
	<el-time-picker v-if="model"
					v-model="model[data.fieldId]"
					:picker-options="{
						selectableRange: data.setting.selectableRange,
						format: data.setting.format
					}"
					:prefix-icon="data.setting.prefixIcon"
					:placeholder="data.placeholder"
					:value-format="data.setting.valueFormat"
					style="width: 100%"
					:disabled="disabled"
					@change="timeChange">
	</el-time-picker>
	<el-time-picker v-else
					v-model="data.value"
					:picker-options="{
						selectableRange: data.setting.selectableRange,
						format: data.setting.format
					}"
					:prefix-icon="data.setting.prefixIcon"
					:placeholder="data.placeholder"
					style="width: 100%"
					:disabled="disabled"
					@change="pickerChange">
	</el-time-picker>
</template>

<script>
import { isHaveKey } from '../../utils/tool'

export default {
	name: 'TpTimePicker',
	props: {
		data: {
			type: Object,
			required: true
		},
		model: Object
	},
	inject: [ 'customFormOptions' ],
	computed: {
		disabled() {
			if (isHaveKey(this.customFormOptions[this.data.fieldId], 'disabled')) {
				return this.customFormOptions[this.data.fieldId].disabled(this.model[this.data.fieldId])
			} else {
				return false
			}
		}
	},
	methods: {
		timeChange(val) {
			if (isHaveKey(this.customFormOptions[this.data.fieldId], 'change')) {
				this.customFormOptions[this.data.fieldId].change(val)
			}
		}
	}
}
</script>